import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { useRecoilState } from 'recoil';
import { outletAtom } from 'core/config/atoms';

import TopBar from 'core/widgets/ui/TopBar';

import PanelDev from 'panels/dev/PanelDev';

import SubPanelA from './subpanel/SubPanelA';
import SubPanelB from './subpanel/SubPanelB';

export default function PanelPosMain() {
    const [outlet] = useRecoilState(outletAtom);

    const [mode, setMode] = useState('A');

    const changePanel = (type) => {
        setMode(type);
    }

    const loadData = () => {
        (async function () {
            if ((outlet.outletid.terminaltype === 'standard' || outlet.outletid.terminaltype === 'cafe')) {
                setMode('A');
            } else {
                setMode('B');
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='h-screen w-full'>
            <div className="w-full h-full py-3 px-[4px]">
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div className="intro-y flex items-center justify-between h-10 border-b pb-4">
                            <h2 className="text-2xl font-medium font-serif truncate ml-2">
                                <div className="intro-y flex items-center cursor-pointer">
                                    {mode === "B" && (outlet.outletid.terminaltype === 'standard' || outlet.outletid.terminaltype === 'cafe') && < i className="las la-long-arrow-alt-left text-xl mr-2" onClick={() => { setMode("A") }}></i>}
                                    <h4 className="text-ascent">POS Terminal</h4>
                                </div>
                            </h2>
                            <TopBar />
                        </div>
                    </div>
                </div>
                <div className="w-full">
                    <ScrollArea className="w-full h-[100vh] overflow-hidden">
                        {
                            (() => {
                                switch (mode) {
                                    case 'A':
                                        return (<SubPanelA changePanel={changePanel} />);
                                    case 'B':
                                        return (<SubPanelB changePanel={changePanel} />);
                                    default:
                                        return (<PanelDev />);
                                }
                            })()
                        }
                    </ScrollArea>
                </div>
            </div>
        </div>
    )
}
